import React from "react";
import ConfirmationPopup from "components/ConfirmationPopup";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useRacehorse360Api } from "hooks/api";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  onClose: (shouldRefreshData?: boolean) => void;
}

const RemoveHorsePopup = (props: IProps) => {
  const { horse, onClose } = props;

  const classes = useStyles();

  const { useUnassignHorseFromTrainer } = useRacehorse360Api();

  const { mutateAsync: unassignHorseFromTrainer } =
    useUnassignHorseFromTrainer();

  const handleUnassignHorse = async () => {
    return unassignHorseFromTrainer({
      horseId: horse.id
    }).then(() => {
      onClose(true);
    });
  };

  return (
    <ConfirmationPopup
      open={true}
      title={"Are you sure?"}
      onConfirm={handleUnassignHorse}
      onCancel={onClose}
      confirmButtonText={"Remove from inventory"}
      cancelButtonText={"Back"}
      notification={`${horse.name} has been removed from your inventory`}
      positive={false}
    >
      <div>
        You are about to remove <strong>{horse.name}</strong> from your
        inventory.
      </div>
      <div className={classes.secondaryContent}>
        Contact your racing office to have a horse added back to your inventory.
      </div>
    </ConfirmationPopup>
  );
};

export default RemoveHorsePopup;
